export default __webpack_public_path__ + "static/media/contactsPink.07d0bb8b.svg";